// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
/** @jsx jsxPragma */

import { jsxPragma } from "@outschool/ui-legacy-component-library";
import { CardNumberElement } from "@stripe/react-stripe-js";
import { CardNumberElementProps } from "@stripe/react-stripe-js/src/types";
import { SystemStyleObject } from "@styled-system/css";
import _ from "lodash";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import { CARD_ELEMENT_OPTIONS, VARIANT_DEFAULT_SX, Variants } from ".";

interface StripeCardNumberProps extends CardNumberElementProps {
  variant?: Variants;
  sx?: SystemStyleObject;
}

export default function StripeCardNumber({
  variant = Variants.valid,
  sx = {},
  options,
  ...props
}: StripeCardNumberProps) {
  return (
    <CardNumberElement
      options={_.merge(CARD_ELEMENT_OPTIONS, options)}
      // @ts-ignore
      sx={_.merge(VARIANT_DEFAULT_SX[variant], sx)}
      {...props}
    />
  );
}
